import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const categoryLinks = [
    { label: t('nav.celebrityGossip'), path: '/category/celebrity-gossip' },
    { label: t('nav.exclusiveScoop'), path: '/category/exclusive-scoop' },
    { label: t('nav.varietyHot'), path: '/category/variety-hot' },
    { label: t('nav.filmTvNews'), path: '/category/film-tv-news' },
    { label: t('nav.influencerNews'), path: '/category/influencer-news' },
  ];

  const quickLinks = [
    { label: t('nav.home'), path: '/' },
    { label: t('nav.about'), path: '/about' },
  ];

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-white rounded-lg font-bold text-sm">
                51
              </span>
              <span className="font-heading font-bold text-xl text-white">
                吃瓜官网
              </span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed">
              {t('footer.aboutDesc')}
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-base mb-4">
              {t('footer.quickLinks')}
            </h4>
            <ul className="flex flex-col gap-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-base mb-4">
              {t('footer.categories')}
            </h4>
            <ul className="flex flex-col gap-2">
              {categoryLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-base mb-4">
              {t('footer.contactTitle')}
            </h4>
            <ul className="flex flex-col gap-2 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>{t('footer.contactEmail')}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>{t('footer.contactWechat')}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            {t('footer.copyright')} | {t('footer.icp')}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-primary-400 text-sm transition-colors cursor-pointer" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-primary-400 text-sm transition-colors cursor-pointer" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-primary-400 text-sm transition-colors cursor-pointer" rel="nofollow">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}